import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { ImageSchema, Shield } from 'images'
import { SimpleButton } from 'ui'
import { ChildrenSchema } from 'utils'

import styles from './index.css'

class TeamButton extends PureComponent {
  render() {
    const { className, image, name, visitor, ...props } = this.props
    return (
      <SimpleButton
        {...props}
        ariaLabel={`Equipo: ${name}`}
        className={classnames(styles.button, className, visitor && styles.visitor)}
        value={name}
      >
        <Shield className={styles.image} src={image} />
        <span className={styles.name}>{name}</span>
      </SimpleButton>
    )
  }
}

TeamButton.propTypes = {
  name: PropTypes.string.isRequired,

  children: ChildrenSchema,
  className: PropTypes.string,
  image: ImageSchema,
  visitor: PropTypes.bool,
}

TeamButton.defaultProps = {
  children: null,
  className: null,
  image: null,
  visitor: false,
}

export default TeamButton
